/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SearchBankTransfers200ResponseInnerRequestedBy } from './search-bank-transfers200-response-inner-requested-by';
// May contain unused imports in some cases
// @ts-ignore
import { SearchBankTransfers200ResponseInnerSourceBankAccount } from './search-bank-transfers200-response-inner-source-bank-account';

/**
 * 
 * @export
 * @interface SearchBankTransfers200ResponseInner
 */
export interface SearchBankTransfers200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'fileFormat': SearchBankTransfers200ResponseInnerFileFormatEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'paymentRequestIds': Array<string>;
    /**
     * 
     * @type {SearchBankTransfers200ResponseInnerSourceBankAccount}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'sourceBankAccount': SearchBankTransfers200ResponseInnerSourceBankAccount;
    /**
     * 
     * @type {SearchBankTransfers200ResponseInnerRequestedBy}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'requestedBy': SearchBankTransfers200ResponseInnerRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'transferAt': string;
    /**
     * null if the transfer data has not been downloaded.
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInner
     */
    'downloadedAt': string | null;
}

export const SearchBankTransfers200ResponseInnerFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type SearchBankTransfers200ResponseInnerFileFormatEnum = typeof SearchBankTransfers200ResponseInnerFileFormatEnum[keyof typeof SearchBankTransfers200ResponseInnerFileFormatEnum];


